(function () {
  if (window.__djiAdditionalItemsBound) return;
  window.__djiAdditionalItemsBound = true;

  var additionalItemSelector =
    '[data-accessory-section] .dji-addon-card__checkbox:checked, ' +
    '[data-care-section] .dji-addon-card__checkbox:checked';

  function findProductScope(form) {
    return form.closest('.shopify-section') || document;
  }

  function getQuantity(checkbox) {
    var quantityInputId = checkbox.dataset.qtyInput;
    var quantityInput = quantityInputId ? document.getElementById(quantityInputId) : null;
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

    return quantity > 0 ? quantity : 1;
  }

  function getSelectedItems(scope) {
    var items = [];
    var itemsByVariant = {};

    scope.querySelectorAll(additionalItemSelector).forEach(function (checkbox) {
      var variantId = parseInt(checkbox.dataset.variantId, 10);
      if (!variantId) return;

      var quantity = getQuantity(checkbox);

      if (itemsByVariant[variantId]) {
        itemsByVariant[variantId].quantity += quantity;
        return;
      }

      var item = {
        id: variantId,
        quantity: quantity
      };

      itemsByVariant[variantId] = item;
      items.push(item);
    });

    return items;
  }

  function removeGeneratedInputs(form) {
    form.querySelectorAll('[data-dji-additional-item]').forEach(function (input) {
      input.remove();
    });
  }

  function appendHiddenInput(form, name, value) {
    var input = document.createElement('input');

    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.setAttribute('data-dji-additional-item', '');
    form.appendChild(input);
  }

  function syncForm(form) {
    if (!form || !form.matches('form[action*="/cart/add"]')) return;

    removeGeneratedInputs(form);

    var scope = findProductScope(form);
    var items = getSelectedItems(scope);

    items.forEach(function (item, index) {
      var shopifyIndex = index + 1;

      appendHiddenInput(form, 'shopify-additional-items[' + shopifyIndex + '][id]', item.id);
      appendHiddenInput(form, 'shopify-additional-items[' + shopifyIndex + '][quantity]', item.quantity);
    });
  }

  function syncAllProductForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.querySelector('.shopify-payment-button')) syncForm(form);
    });
  }

  function scheduleSync() {
    window.requestAnimationFrame(syncAllProductForms);
  }

  window.DjiAdditionalItems = {
    syncForm: syncForm
  };

  document.addEventListener('change', function (event) {
    if (event.target.matches('.dji-addon-card__checkbox, .dji-qty-input')) {
      scheduleSync();
    }
  });

  document.addEventListener('input', function (event) {
    if (event.target.matches('.dji-qty-input')) scheduleSync();
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('.dji-qty-btn')) {
      scheduleSync();
      return;
    }

    var paymentButton = event.target.closest(
      '.shopify-payment-button__button, ' +
      '.shopify-payment-button button, ' +
      '[data-shopify="payment-button"] button'
    );

    if (!paymentButton) return;

    var form = paymentButton.closest('form[action*="/cart/add"]');
    syncForm(form);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllProductForms);
  } else {
    syncAllProductForms();
  }

  document.addEventListener('shopify:section:load', syncAllProductForms);

  window.addEventListener('pageshow', function () {
    scheduleSync();
  });
})();
